<form class="pay-invoice-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INCORRECT_PAYMENT.PAY_INVOICE' | translate }}</h4>
  <div class="pay-invoice-form__content">
    <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
      <app-money-box
        [control]="form.controls['amount']"
        [helpText]="'INCORRECT_PAYMENT.HELP_TEXT.PAY_INVOICE_AMOUNT'"
      ></app-money-box>
      <div class="astral-layout-item">
        <app-autocomplete-remote-paged
          [control]="form.controls['invoice']"
          [helpText]="'INCORRECT_PAYMENT.PAY_INVOICE_HELP_TEXT'"
          [service]="filterService"
          [defaultSearch]="'*'"
          [serviceOptions]="invoiceSearchOptions"
          [updateOnOptionsChange]="true"
          [enableInfiniteScroll]="true"
          (itemSelected)="invoiceSelected($event)"
        ></app-autocomplete-remote-paged>
        <astral-checkbox [control]="form.controls['includeAllCompanies']"></astral-checkbox>
      </div>
      @if (differentCompany) {
        <app-information-block [text]="'INCORRECT_PAYMENT.WARN_DIFFERENT_COMPANY' | translate"></app-information-block>
        <astral-select [control]="form.controls['companyBankAccountId']" [itemsSource]="accountSelection"></astral-select>
      }
      @if (surplusAmount) {
        <div class="pay-invoice-form__surplus">
          <span>{{ 'INCORRECT_PAYMENT.WARN_DIFFERENT_COMPANY_SURPLUS' | translate }}</span>
          <app-money-box [dataContext]="surplusAmount"></app-money-box>
        </div>
      }
      <astral-date-picker
        [control]="form.controls['businessTransactionDate']"
        [label]="'PAYMENT.DATE'"
        [model]="dataContext.businessTransactionDate"
        [isRequired]="true"
      ></astral-date-picker>
    </section>
    <section class="pay-invoice-form__information astral-section-surface astral-section-surface--compact astral-stack-m">
      <h3 class="pay-invoice-form__information-heading astral-section-heading">
        {{ 'INCORRECT_PAYMENT.INFORMATION' | translate }}
      </h3>
      <astral-button
        class="pay-invoice-form__information-toggle"
        variant="secondary"
        type="button"
        [ariaPressed]="informationExpanded"
        [labelKey]="informationExpanded ? 'INCORRECT_PAYMENT.HIDE_INFORMATION' : 'INCORRECT_PAYMENT.SHOW_INFORMATION'"
        (click)="toggleInformation()"
      ></astral-button>
      <dl
        class="pay-invoice-form__information-content"
        [class.pay-invoice-form__information-content--expanded]="informationExpanded"
      >
        <div class="pay-invoice-form__information-item">
          <dt>{{ 'COMMON.COMPANY' | translate }}</dt>
          <dd>{{ dataContext.companyName || ('COMMON.NOT_SPECIFIED' | translate) }}</dd>
        </div>
        <div class="pay-invoice-form__information-item">
          <dt>{{ 'INCORRECT_PAYMENT.PAYER' | translate }}</dt>
          <dd>{{ dataContext.payerNameAndAddress || ('COMMON.NOT_SPECIFIED' | translate) }}</dd>
        </div>
        <div class="pay-invoice-form__information-item">
          <dt>{{ 'INCORRECT_PAYMENT.DESCRIPTION' | translate }}</dt>
          <dd>{{ dataContext.description || ('COMMON.NOT_SPECIFIED' | translate) }}</dd>
        </div>
      </dl>
    </section>
  </div>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
